import { ReactNode } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import BeatLoader from "react-spinners/PulseLoader";

interface LoadingProps {
  children?: ReactNode;
  className?: string;
  isLoader?: boolean;
}

const LoaderCustom = ({
  children,
  className,
  isLoader = true,
}: LoadingProps) => {
  return (
    <div
      className={twMerge(
        clsx(
          "fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-70 z-50",
          className
        )
      )}
    >
      <div className="flex flex-col items-center">
        <div>
          <h3 className="font-bold text-photo-time-pink-main text-[1.5em] sm:text-[2em] md:text-[3em] lg:text-[5em] tracking-wider">
            PHOTO TIME
          </h3>
        </div>
        <BeatLoader loading={isLoader} color="#D12E93" speedMultiplier={0.5} />
      </div>
    </div>
  );
};

export default LoaderCustom;
